// src/seo/siteSeo.js
// <head> for RouteChef's main pages (home, Plan a Trip, partners, contact) and the site-wide
// structured data (WebSite, Organization, the key links). scripts/seo-build.mjs prerenders the same
// pages and puts siteJsonLd() into every page's HTML, so crawlers see the site name, logo and key links.
import { SITE } from "./seo";
import { MAIN_LINKS, TRIP_LINKS, PARTNER_LINKS } from "../config/siteNav";

const IMG = "/trips/hornbill/morung-1600.jpg";

export const homeSeo = () => ({
    title: "RouteChef: Trains, Flights and Buses in One Search, Plus Trip Plans",
    description: "Find the best way to travel across India: trains, flights and buses together, with connections when nothing is direct. Plan trips day by day with live travel and stays.",
    canonical: `${SITE}/`,
    image: IMG,
});

export const planTripSeo = () => ({
    title: "Plan a Trip in India: Day by Day Plans with Live Travel | RouteChef",
    description: "Pick a ready trip, set your start city and dates, and get a day by day plan with live trains, flights, buses and stays from local operators. Change anything, then ask for the best price.",
    canonical: `${SITE}/plan-a-trip`,
    image: IMG,
});

export const partnerSeo = () => ({
    title: "Become a RouteChef Partner: List Your Trips, Get Traveller Leads",
    description: "For DMCs, tour operators and travel agents. List your packages on RouteChef, get traveller chats and calls on WhatsApp, and let travellers add live trains, flights and buses to your trips.",
    canonical: `${SITE}/partner-signup`,
    image: IMG,
});

export const listTripSeo = () => ({
    title: "Turn Your Itinerary PDF into a Trip Page | RouteChef for Tour Operators",
    description: "Upload the itinerary PDF you send customers and get your own trip page in minutes: day plan, hotels and prices. Customers customise it, leads reach you on WhatsApp. Free for the first 100 operators.",
    canonical: `${SITE}/list-your-trip`,
    image: IMG,
});

export const contactSeo = () => ({
    title: "Contact RouteChef",
    description: "Questions about a booking, a trip or partnering with RouteChef? Write to us and our team gets back to you.",
    canonical: `${SITE}/contact`,
});

/** WebSite + Organization + the key links (what we'd like Google to show under a RouteChef search) */
export function siteJsonLd() {
    const links = [
        ...MAIN_LINKS.filter((l) => l.to).map((l) => ({ name: l.label, url: `${SITE}${l.to}`, description: l.desc })),
        ...TRIP_LINKS.map((t) => ({ name: t.label, url: `${SITE}${t.to}`, description: t.sub })),
        ...PARTNER_LINKS.map((t) => ({ name: t.label, url: `${SITE}${t.to}`, description: t.sub })),
    ];
    return {
        "@context": "https://schema.org",
        "@graph": [
            {
                "@type": "WebSite", "@id": `${SITE}/#website`, name: "RouteChef", alternateName: ["Routechef", "RouteChef Labs"],
                url: `${SITE}/`, inLanguage: "en-IN", publisher: { "@id": `${SITE}/#org` },
            },
            {
                "@type": "Organization", "@id": `${SITE}/#org`, name: "RouteChef", legalName: "RouteChef Labs Pvt Ltd",
                url: `${SITE}/`, logo: `${SITE}/logo_new.svg`, email: "info@routechef.com",
                sameAs: ["https://www.facebook.com/routechef/", "https://www.linkedin.com/company/105943037", "https://www.instagram.com/routechef/"],
                contactPoint: [{ "@type": "ContactPoint", contactType: "customer support", email: "info@routechef.com", areaServed: "IN", availableLanguage: ["en", "hi"] }],
            },
            {
                "@type": "ItemList", "@id": `${SITE}/#key-pages`, name: "RouteChef key pages",
                itemListElement: links.map((l, i) => ({ "@type": "SiteNavigationElement", position: i + 1, name: l.name, url: l.url, description: l.description })),
            },
        ],
    };
}
